import { render, staticRenderFns } from "./AddToHomeScreen.vue?vue&type=template&id=25020721&scoped=true&lang=pug&"
import script from "./AddToHomeScreen.vue?vue&type=script&lang=ts&"
export * from "./AddToHomeScreen.vue?vue&type=script&lang=ts&"
import style0 from "./AddToHomeScreen.vue?vue&type=style&index=0&id=25020721&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25020721",
  null
  
)

export default component.exports